import { Effect } from 'effect';

import { RuntimeClientAtom } from '../../runtime/RuntimeClient';
import { SupportBox } from '../../service/supportBox/SupportBox';
import * as Atom from 'effect/unstable/reactivity/Atom';

export const openCartDrawerAtom = Atom.make(false);

export const supportBoxInCartDrawerAtom = RuntimeClientAtom.atom((get) =>
  Effect.gen(function* () {
    const isCartDrawerOpen = get(openCartDrawerAtom);
    const supportBox = yield* SupportBox;

    if (isCartDrawerOpen) {
      yield* supportBox.hide;
    } else {
      yield* supportBox.show;
    }

    const state = yield* supportBox.getState;
    return !state.isHidden;
  })
);
